import request from './request'

export interface UploadResponse {
  code: number
  msg: string
  data: {
    url: string
    [key: string]: unknown
  }
}

export interface UploadParams {
  file: File
  category?: string
}

/** POST `/api/admin/upload` 通用文件上传 */
export async function uploadFile(params: UploadParams): Promise<UploadResponse> {
  const formData = new FormData()
  formData.append('category', params.category ?? 'general')
  formData.append('file', params.file)

  const response = await request.post<UploadResponse>('/api/admin/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response
}
